<script>
    import { createEventDispatcher } from 'svelte';

    export let tiers = [];
    export let selectedTierGuid = null;

    const dispatch = createEventDispatcher();

    function labelFor(tier) {
        if (tier.name) return tier.name;
        return tier.atp ? 'Coach' : 'Monitor';
    }

    function blurbFor(tier) {
        if (tier.atp) return 'Includes workout plans and coaching features.';
        return 'Monitoring only. No workout plans.';
    }

    function select(guid) {
        dispatch('select', guid);
    }
</script>

<div class="text-left">
    <span class="text-gray-800 font-medium">Choose your access</span>
    <p class="text-xs text-gray-500 mt-1">Coach includes workout plans. Monitor is data-only and costs less.</p>
</div>
<div class="grid grid-cols-1 gap-3" style="grid-template-columns: repeat({tiers.length}, minmax(0, 1fr));">
    {#each tiers as tier}
    <button
        type="button"
        class="relative rounded-xl border-2 p-4 text-left transition-all cursor-pointer
            {selectedTierGuid === tier.guid ? 'border-[var(--secondary-color)]' : 'border-gray-200 hover:border-gray-300'}"
        style={selectedTierGuid === tier.guid ? `border-color: var(--secondary-color); background-color: color-mix(in srgb, var(--secondary-color) 6%, white)` : ''}
        on:click={() => select(tier.guid)}
    >
        <div class="flex items-center justify-between">
            <span class="font-semibold text-gray-800">{labelFor(tier)}</span>
            <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center
                {selectedTierGuid === tier.guid ? 'border-[var(--secondary-color)]' : 'border-gray-300'}">
                {#if selectedTierGuid === tier.guid}
                <div class="w-3 h-3 rounded-full bg-[var(--secondary-color)]"></div>
                {/if}
            </div>
        </div>
        <p class="text-xs text-gray-500 mt-2">{blurbFor(tier)}</p>
    </button>
    {/each}
</div>
